export const socialSelectList = [
  { value: '', label: '--Escoge una opción--' },
  { value: 'LinkedIn', label: 'LinkedIn' },
  { value: 'Google', label: 'Google' },
  { value: 'Company Website', label: 'Company Website' },
  { value: 'Events', label: 'Events' },
  { value: 'Press Releases', label: 'Press Releases' },
  { value: 'Blog', label: 'Blog' },
  { value: 'Podcast', label: 'Podcast' },
  { value: 'Other channels', label: 'Otros canales' }
];